import { useParams, Navigate } from 'react-router-dom';

import PersonalInfo from './components/stepRouter/PersonalInfo';
import Identification from './components/stepRouter/Identification';
import FirstAid from './components/stepRouter/FirstAid';
import Qualifications from './components/stepRouter/Qualifications';
import ContractorAgreement from './components/stepRouter/ContractorAgreement';
import Locations from './components/stepRouter/Locations';
import Offerings from './components/stepRouter/Offerings';
import Waiver from './components/stepRouter/Waiver';
import Profile from './components/stepRouter/Profile';

const StepRouter = () => {
  const params = useParams();

  if (!params.stepKey) {
    return (
      <Navigate
        to={`/coach/${params.id}/activities/${params.coachActivityId}/personal-information`}
      />
    );
  }

  switch (params.stepKey) {
    case 'personal-information':
      return <PersonalInfo />;
    case 'identification':
      return <Identification />;
    case 'first-aid':
      return <FirstAid />;
    case 'qualifications':
      return <Qualifications />;
    case 'contractor-agreement':
      return <ContractorAgreement />;
    case 'locations':
      return <Locations />;
    case 'offerings':
      return <Offerings />;
    case 'waiver':
      return <Waiver />;
    case 'profile':
      return <Profile />;
  }
};

export default StepRouter;
